import * as actionsTypes from './actions';

const initialState = {
    isLoading: false,
    allDevices: {},
    device: {},
    agency_msc: {},
    isSubmitBtnloading: false,
    mscListLoading: false
}

export default function (state = { ...initialState }, action) {
    switch (action.type) {

        case actionsTypes.GET_ALL_AGENCY_DEVIECS_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_ALL_AGENCY_DEVIECS_SUCCESS:
            return { ...state, isLoading: false, allDevices: action.payload || {} }

        case actionsTypes.GET_ALL_AGENCY_DEVIECS_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_AGENCY_DEVICE_DETAIL_REQUEST:
            return { ...state, isLoading: true }

        case actionsTypes.GET_AGENCY_DEVICE_DETAIL_SUCCESS:
            return { ...state, isLoading: false, device: action.payload || {} }

        case actionsTypes.GET_AGENCY_DEVICE_DETAIL_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.CLEAR_ALL_DEVICE_DATA:
            return { ...state, ...initialState }

        case actionsTypes.UPDATE_AGENCY_DEVICE_DETAIL_REQUEST:
            return { ...state, isLoading: true, }

        case actionsTypes.UPDATE_AGENCY_DEVICE_DETAIL_SUCCESS:
            return { ...state, isLoading: false }

        case actionsTypes.UPDATE_AGENCY_DEVICE_DETAIL_FAILED:
            return { ...state, isLoading: false }

        case actionsTypes.GET_AGENCY_DEVICE_HISTORY_REQUEST:
            return { ...state, isLoading: true, deviceHistory: [] }

        case actionsTypes.GET_AGENCY_DEVICE_HISTORY_SUCCESS:
            return { ...state, isLoading: false, deviceHistory: action.payload }

        case actionsTypes.GET_AGENCY_DEVICE_HISTORY_FAILED:
            return { ...state, isLoading: false }
        
        case actionsTypes.GET_AGENCY_MSC_REQUEST:
            return { ...state, mscListLoading: true}

        case actionsTypes.GET_AGENCY_MSC_SUCCESS:
            return { ...state, mscListLoading: false, agency_msc: action.payload }

        case actionsTypes.GET_AGENCY_MSC_FAILED:
            return { ...state, mscListLoading: false }

        case actionsTypes.ASSIGN_DEVICES_REQUEST:
            return { ...state, isSubmitBtnloading: true }
    
        case actionsTypes.ASSIGN_DEVICES_SUCCESS:
            return { ...state, isSubmitBtnloading: false }

        case actionsTypes.ASSIGN_DEVICES_FAILED:
            return { ...state, isSubmitBtnloading: false }

        default:
            return state
    }
}